import axios from 'axios'
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { useGolferStore } from './GolferStore'
import { useMetaStore } from './MetaStore'

export const useRoundStore = create()(
  persist(
    (set, get) => ({
      roundDate: get()?.roundDate || '',
      setRoundDate: (roundDate) => set({ roundDate }),
      roundHoleCount: get()?.roundHoleCount || 9,
      setRoundHoleCount: (roundHoleCount) => set({ roundHoleCount }),
      holeNum: get()?.roundHoleNum || 1,
      setHoleNum: (holeNum) => set({ holeNum }),
      setTriggerSave: (triggerSave) => set({ triggerSave }),
      saveData: async () => {
        try {
          const triggerSave = useRoundStore.getState().triggerSave
          const groupRounds = useGolferStore.getState().groupRounds
          const apiKey = useMetaStore.getState().apiKey
          const setTriggerSave = useRoundStore.getState().setTriggerSave

          if (triggerSave) {
            const resp = await axios.post(
              '/gskapi/rounds/saverounds',
              {
                groupRounds,
                roundHoleCount: useRoundStore.getState().roundHoleCount,
              },
              {
                headers: { 'api-token': apiKey },
              }
            )

            setTriggerSave(false)
            return { status: 'SUCCESSS' }
          } else {
            return { status: 'NOT_TRIGGERED' }
          }
        } catch (error) {
          console.error('Error saving data:', error)
          return { status: 'ERROR', error: error.message }
        }
      },
    }),
    {
      name: 'gsk-round',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
